<template>
    <div class="TextInputmain">
        <v-text-field :class="[currentField.required ? required_class : currentField.readonly ? read_only : others]"
            :readonly="currentField.clearable" :disabled='attributesBinding.disabled'
            :placeholder="`${currentField.isPlaceholderVisible ? attributesBinding.placeholder : ''}`"
            v-model="input_value" :label="`${currentField.label}`" :rules="required_rule" :type="input">
        </v-text-field>
    </div>
</template>

<script>
export default {
    name: 'TextInput',
    props: ['currentField', 'Allfields', 'MaskingModules', 'ChartoMaskingChar', 'Filename', 'masking'],
    data() {
        return {
            input_value: "",
            input: '',
            required_class: "required",
            others: "others",
            read_only: "readonly",
            required_rule: [],
            mask: false
        }
    },
    watch: {
        input_value: function (newVal) {
            let scope = this
            if (!scope.mask) {
                scope.currentField.value.value = newVal;
            }
        }
    },
    destroyed() {
        this.currentField.value.value = '';
    },
    computed: {
        attributesBinding() {
            var attr = {};
            attr['id'] = this.currentField.model;
            if (this.currentField.showWordLimit) {
                attr.maxlength = this.currentField.maxlength;
                attr['show-word-limit'] = this.currentField.showWordLimit
            }
            if (this.currentField.clearable) {
                attr.clearable = this.currentField.clearable;
            }
            if (this.currentField.disabled) {
                attr.disabled = this.currentField.disabled;
            }
            if (this.currentField.showPassword) {
                attr['show-password'] = this.currentField.showPassword;
            }
            if (this.currentField.isPlaceholderVisible) {
                attr.placeholder = this.currentField.placeholder;
            }
            return attr;
        },
    },
    mounted() {



        let scope = this
        if (this.currentField.required == true) {
            this.required_rule.push(v => !!v || `${this.currentField.label} is required`)

            if (this.currentField.model_type == "SmallNumber") {
                this.required_rule.concat([v => String(v).length > 32767 || "The value must be an less then 32767"])
            }
            // this.required_rule.push(v => !!v || `${this.currentField.label} is required`)
            if (this.currentField.type === 'phone_number') {
                console.log(this.currentField.required, "momomomo");

                this.required_rule.push(
                    v => {
                        if (!this.currentField.required && (!v || v === '')) {
                            return true; // Skip validation if the field is not required and empty
                        }
                        const value = (v || '').toString(); // Ensure value is a string
                        return value.includes('X') || /^\d+$/.test(value) || `${this.currentField.label} must contain only numbers`;
                    },
                    v => {
                        if (!this.currentField.required && (!v || v === '')) {
                            return true;
                        }
                        const value = (v || '').toString();
                        return value.includes('X') || /^\d+$/.test(value) || "Only numbers are allowed";
                    },
                    v => {
                        if (!this.currentField.required && (!v || v === '')) {
                            return true;
                        }
                        const value = (v || '').toString();
                        return value.includes('X') || (value.length <= 14) || `${this.currentField.label} cannot be longer than 14 characters`;
                    },
                    v => {
                        if (!this.currentField.required && (!v || v === '')) {
                            return true;
                        }
                        const value = (v || '').toString();
                        return value.includes('X') || /^(?!000)\d{1,2}\d{1,15}$/.test(value) || `${this.currentField.label} not valid number`;
                    },
                    v => {
                        if (!this.currentField.required && (!v || v === '')) {
                            return true;
                        }
                        const value = (v || '').toString();
                        return value.includes('X') || /^(?!0{1,2}$)\d+$/.test(value) || `${this.currentField.label} not valid number`;
                    }
                );


                this.input_value = this.currentField.value.value;
            }
            else if (this.currentField.type === 'email') {
                this.required_rule.push(
                    v => {
                        if (!this.currentField.required && (!v || v === '')) {
                            return true;
                        }
                        return v.includes('X') || /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(v) || `Enter valid Email ID with lowercase`;
                    }
                );

                this.input_value = this.currentField.value.value;
            }
            else {
                this.input = this.currentField.model_type === "BigNumber" || this.currentField.model_type === "SmallNumber" || this.currentField.model_type === "Number" ? "number" : "text";
                this.input_value = this.currentField.value.value;
            }
        }
        if (scope.masking && scope.currentField.model == scope.MaskingModules[scope.Filename].find(elm => elm == scope.currentField.model) && scope.currentField.value.value != "") {
            scope.mask = true
            scope.input = "text"
            scope.input_value = scope.ChartoMaskingChar(scope.currentField.value.value)
            scope.currentField.clearable = true
        } else {
            scope.mask = false
            scope.input_value = scope.currentField.value.value
            if (this.currentField.model_type == "BigNumber" || this.currentField.model_type == "SmallNumber" || this.currentField.model_type == "Number") {
                this.input = "number"
                if (this.currentField.model_type == "SmallNumber") {
                    this.required_rule = [v => Number(v) <= 32767 || "The value type is SmallNumber must be an less then 32767"]
                }
            } else {
                this.input = "text"
            }
        }
        if (this.currentField.type === 'phone_number') {
            this.input = "text"
        }
    },
}
</script>

<style>
.TextInput {
    margin: 20px 10px 10px 10px;
}

.TextInputmain {
    display: flex;
    padding: 10px;
    height: 85px;
}

.required:after {
    content: " *";
    color: rgb(255, 0, 0);
    font-weight: 600;
    padding-left: 2px;
}

.readonly:after {
    content: " *";
    color: rgb(4, 0, 255);
    font-weight: 600;
    padding-left: 2px;
}

.others:after {
    content: "";
    font-weight: 600;
    padding-left: 2px;
}
</style>
